import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

class IndustryTeamList {
  constructor(component) {
    this.refs = {
      slider: '.js-members-slider',
      prev: '.js-prev',
      next: '.js-next',
      slide: '.js-slide',
    };
    
    this.dom = {
      $slider: component.querySelector(this.refs.slider),
      $prev: component.querySelector(this.refs.prev),
      $next: component.querySelector(this.refs.next),
      $slides: component.querySelectorAll(this.refs.slide),
    };

    this.state = {
      swiper: null,
    };

    this.mount();
  }

  mount() {
    const { dom } = this;

    const options = {
      modules: [Navigation],
      slidesPerView: 'auto',
      spaceBetween: 10,
      slidesOffsetBefore: 15,
      loop: true,
      navigation: {
        prevEl: dom.$prev,
        nextEl: dom.$next,
      },
      on: {
        afterInit: (swiper) => {
          swiper.loopFix();
        },
        slideChangeTransitionEnd: (swiper) => {
          swiper.loopFix();
        }
      }
    }

    if (dom.$slides.length <= 3) {
      options.loop = false;
      options.slidesOffsetAfter = 15;
    }

    // Initialize Swiper slider
    this.state.swiper = new Swiper(dom.$slider, options);
  }
}

const $industryTeamList = document.querySelector('.js-industry-team-list');
if ($industryTeamList) new IndustryTeamList($industryTeamList);